import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme, disabled }) => ({
  width: "100%",
  borderRadius: "5px",
  backgroundColor: "#ffffff",
  boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.1)",
  border: "none",
  pointerEvents: disabled ? "none" : "auto",
  opacity: disabled ? 0.66 : 1,
}));

const CustomCard = ({ children, disabled }) => {
  return <StyledCard disabled={disabled}>{children}</StyledCard>;
};

export default CustomCard;
